import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { card, inputCls, btnPrimary, usd, errMsg } from "./shared";

export function SpendEntryForm({ onSaved, fee = 0 }) {
  const { refresh } = useAuth();
  const [f, setF] = useState({ identifier: "", amount: "", note: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    const amount = Number(f.amount);
    if (!amount) return toast.error("Enter a non-zero amount");
    setBusy(true);
    try {
      const { data: cust } = await api.get("/market/customer-lookup", { params: { identifier: f.identifier } });
      const verb = amount > 0 ? `add ${usd(amount)} to` : `deduct ${usd(Math.abs(amount))} from`;
      const feeNote = amount > 0 && fee > 0 ? `\n${fee} Credit${fee === 1 ? "" : "s"} will be deducted from your balance.` : "";
      if (!window.confirm(`Confirm: ${verb} ${cust.name}'s all-time spending?${feeNote}`)) return;
      await api.post("/market/business/spend", { ...f, amount });
      toast.success(`Saved for ${cust.name}`);
      setF({ identifier: "", amount: "", note: "" });
      onSaved();
      refresh?.();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={save} className={`${card} p-5 space-y-3`} data-testid="spend-entry-form">
      <p className="font-heading text-lg font-black text-sky-950">Record a customer's spending</p>
      <p className="text-xs text-sky-700/70">Over-credited someone? Enter a negative amount (e.g. -20) to correct it — corrections are free.</p>
      {fee > 0 && <p data-testid="spend-fee-note" className="text-xs font-bold text-sky-800">Each entry costs {fee} Credit{fee === 1 ? "" : "s"}.</p>}
      <input data-testid="spend-identifier" className={inputCls} placeholder="Customer Account ID or Referral ID" value={f.identifier} onChange={set("identifier")} required />
      <input data-testid="spend-amount" type="number" step="0.01" className={inputCls} placeholder="Amount spent in $ (e.g. 50 or -20)" value={f.amount} onChange={set("amount")} required />
      <input data-testid="spend-note" className={inputCls} placeholder="What they bought (optional)" value={f.note} onChange={set("note")} />
      <button data-testid="spend-save" type="submit" className={`${btnPrimary} w-full`} disabled={busy}>{busy ? "Saving…" : "Save"}</button>
    </form>
  );
}
